export default {
    users: {},
    filteredCampaigns: [],
    filteredLeadTypes: [],
    viewId: null,
    notificationDate: null,
    selectedDashboardView: null,
    dashboardViews: {},
    pagination: {
        currentPage: undefined,
        lastPage: undefined,
        perPage: undefined,
        from: undefined,
        to: undefined,
        total: undefined,
        orderBy: 'date',
        sortBy: 'desc',
    },
    filters: {},
    filterApplied: false,
    bulkSelect: [],
    blackListedLeadIds: [],
    allLeadsInTableSelected: false,
    filteredDates: [],
    startContractDate: null,
    tableLeads: [],
    storedStartDate: null,
    storedEndDate: null,
    sharedDashboardViews: {},
};
